import React, { useEffect, useState, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";

// import {
//   // Home,
//   Product,
//   Products,
//   AboutPage,
//   ContactPage,
//   Cart,
//   Login,
//   Register,
//   Checkout,
//   PageNotFound,
// } from "./pages";

import { BarLoader } from "react-spinners";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "react-hot-toast";

import { Amplify, Auth } from "aws-amplify";
import { Authenticator, Button, Heading } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import ZenuRequestDelete from "./pages/ZenuRequestDelete";
import Jobs from "./pages/Jobs";
import VerifyCerti from "./pages/VerifyCerti";

const a0_0x30bf58 = a0_0x1cae;
(function (_0x5f4fb3, _0x34f326) {
  const _0x365f54 = a0_0x1cae;
  const _0x478596 = _0x5f4fb3();
  while (!![]) {
    try {
      const _0x2922d9 =
        parseInt(_0x365f54(0x173)) / 0x1 +
        parseInt(_0x365f54(0x174)) / 0x2 +
        (-parseInt(_0x365f54(0x178)) / 0x3) *
          (-parseInt(_0x365f54(0x16a)) / 0x4) +
        (-parseInt(_0x365f54(0x17c)) / 0x5) *
          (-parseInt(_0x365f54(0x176)) / 0x6) +
        parseInt(_0x365f54(0x17d)) / 0x7 +
        (parseInt(_0x365f54(0x180)) / 0x8) *
          (-parseInt(_0x365f54(0x181)) / 0x9) +
        (parseInt(_0x365f54(0x171)) / 0xa) *
          (-parseInt(_0x365f54(0x167)) / 0xb);
      if (_0x2922d9 === _0x34f326) {
        break;
      } else {
        _0x478596["push"](_0x478596["shift"]());
      }
    } catch (_0x14c97b) {
      _0x478596["push"](_0x478596["shift"]());
    }
  }
})(a0_0x514d, 0xf39d3);
function a0_0x1cae(_0x229dae, _0x441d77) {
  const _0x514d7c = a0_0x514d();
  a0_0x1cae = function (_0x1cae16, _0x182276) {
    _0x1cae16 = _0x1cae16 - 0x166;
    let _0xc19360 = _0x514d7c[_0x1cae16];
    return _0xc19360;
  };
  return a0_0x1cae(_0x229dae, _0x441d77);
}
const AmpConfig = {
  Auth: {
    mandatorySignIn: "true",
    aws_cognito_identity_pool_id:
      a0_0x30bf58(0x16b) +
      a0_0x30bf58(0x17a) +
      a0_0x30bf58(0x179) +
      a0_0x30bf58(0x177) +
      "8b3a416",
    identityPoolId:
      "ap-south-1" +
      a0_0x30bf58(0x17a) +
      "7d84-4ba2-" +
      "9762-8082d" +
      "8b3a416",
    region: a0_0x30bf58(0x16b),
    userPoolId: "ap-south-1" + a0_0x30bf58(0x169),
    userPoolWebClientId:
      a0_0x30bf58(0x16f) + a0_0x30bf58(0x17b) + a0_0x30bf58(0x16c),
    authenticationFlowType: a0_0x30bf58(0x166) + "UTH",
  },
  Storage: {
    bucket: a0_0x30bf58(0x172) + a0_0x30bf58(0x17e) + "e",
    region: a0_0x30bf58(0x16b),
    identityPoolId:
      "ap-south-1" +
      a0_0x30bf58(0x17a) +
      a0_0x30bf58(0x179) +
      a0_0x30bf58(0x177) +
      a0_0x30bf58(0x168),
  },
  Analytics: { disabled: !![] },
  API: {
    aws_appsync_graphqlEndpoint:
      "https://dz" +
      a0_0x30bf58(0x170) +
      a0_0x30bf58(0x17f) +
      a0_0x30bf58(0x16e) +
      "nc-api.ap-" +
      a0_0x30bf58(0x175) +
      a0_0x30bf58(0x16d) +
      "m/graphql",
    aws_appsync_region: a0_0x30bf58(0x16b),
    aws_appsync_authenticationType: "AWS_IAM",
  },
};
function a0_0x514d() {
  const _0x45a8f1 = [
    "south-1.am",
    "51180pAkfVy",
    "9762-8082d",
    "9WvSUjb",
    "7d84-4ba2-",
    ":f96cc20c-",
    "ujdu0b1beq",
    "210ZBqOML",
    "13520003skypBX",
    "touploadon",
    "rngddiwvmk",
    "2543536sOfeIJ",
    "27JRUAcL",
    "USER_SRP_A",
    "23914627wGkCpv",
    "8b3a416",
    "_dIV8ryNSb",
    "2513724TisnvU",
    "ap-south-1",
    "58rkj",
    "azonaws.co",
    "xzii.appsy",
    "nka7imr8ra",
    "bmvksaazat",
    "20uKpxlz",
    "ssssbucket",
    "1710385xpUdAz",
    "828832YtMsPD",
  ];
  a0_0x514d = function () {
    return _0x45a8f1;
  };
  return a0_0x514d();
}

Amplify.configure(AmpConfig);
const Home = React.lazy(() => import("./pages/Home"));
const Product = React.lazy(() => import("./pages/Product"));
const Products = React.lazy(() => import("./pages/Products"));
const AboutPage = React.lazy(() => import("./pages/AboutPage"));
const ContactPage = React.lazy(() => import("./pages/ContactPage"));
const PageNotFound = React.lazy(() => import("./pages/PageNotFound"));

const App = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  useEffect(() => {
    const checkUserLoggedIn = async () => {
      console.log("========== cccc");
      try {
        let data = await Auth.currentUserCredentials({ bypassCache: true });

        // console.log(" ============= xxxxxxxx ============== ")
        setIsUserLoggedIn(true);
        // alert(data);
      } catch (err) {
        setIsUserLoggedIn(false);
        // alert("Some error occured 101");
      }
    };

    checkUserLoggedIn();
  });

  return (
    <>
      <ScrollToTop>
        <Provider store={store}>
          <Suspense
            fallback={
              <div
                style={{
                  width: "100%",
                  // backgroundColor: "red",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <h2 style={{ marginTop: 30 }}>ZENFURA</h2>
                <BarLoader
                  lodaing
                  color="red"
                  width={"500%"}
                  cssOverride={{ marginTop: 15 }}
                />
              </div>
            }
          >
            <Routes>
              <Route
                path="/"
                element={
                  <Home
                    isUserLoggedIn={isUserLoggedIn}
                    setIsUserLoggedIn={setIsUserLoggedIn}
                  />
                }
              />
              <Route
                path="/products"
                element={
                  <Products
                    isUserLoggedIn={isUserLoggedIn}
                    setIsUserLoggedIn={setIsUserLoggedIn}
                  />
                }
              />
              <Route
                path="/product/:page/:id"
                element={
                  <Product
                    isUserLoggedIn={isUserLoggedIn}
                    setIsUserLoggedIn={setIsUserLoggedIn}
                  />
                }
              />

              <Route
                path="/records/:certi_id"
                element={
                  <VerifyCerti
                    isUserLoggedIn={isUserLoggedIn}
                    setIsUserLoggedIn={setIsUserLoggedIn}
                  />
                }
              />

              <Route
                path="/about"
                element={
                  <AboutPage
                    isUserLoggedIn={isUserLoggedIn}
                    setIsUserLoggedIn={setIsUserLoggedIn}
                  />
                }
              />
              <Route
                path="/contact"
                element={
                  <ContactPage
                    isUserLoggedIn={isUserLoggedIn}
                    setIsUserLoggedIn={setIsUserLoggedIn}
                  />
                }
              />
              <Route path="/requestDelete" element={<ZenuRequestDelete />} />
              {/* <Route path="/cart" element={<Cart />} /> */}
              {/* <Route path="/login" element={<Login />} /> */}
              {/* <Route path="/register" element={<Register />} /> */}
              {/* <Route path="/checkout" element={<Checkout />} /> */}
              <Route
                path="/jobs"
                element={
                  <Jobs
                    isUserLoggedIn={isUserLoggedIn}
                    setIsUserLoggedIn={setIsUserLoggedIn}
                  />
                }
              />
              <Route path="*" element={<PageNotFound />} />
              <Route path="/course/*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
        </Provider>
      </ScrollToTop>
    </>
  );
};

export default App;
